import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HqService {
  constructor(private http: HttpClient) { }

  search(criteria: any) {
    return firstValueFrom(this.http.post<HqSearchResult>('/api/hq/search', criteria));
  }

  get(id: string) {
    return firstValueFrom(this.http.get<any>('/api/hq/get/' + id));
  }

  getByDomain(domain: string) {
    return firstValueFrom(this.http.get<any>('/api/hq/by-domain', { params: { domain } }));
  }

  getBranches(id: string) {
    return firstValueFrom(this.http.get<{ List: any[], Total: number }>('/api/hq/' + id + '/branches'));
  }

  save(hq: any) {
    return firstValueFrom(this.http.post<any>('/api/hq/save', hq));
  }

  delete(id: string) {
    return firstValueFrom(this.http.delete<void>('/api/hq/delete/' + id));
  }
}

export type HqSearchResult = { List: any[]; Total: number; };
